// extracted by mini-css-extract-plugin
export var trustPilotContainer = "C_b5";